import { useEffect, useState } from "react";
import EcommerceHeader from "../components/EcommerceHeader";
import { EcommerceFooter } from "./EcommerceHome";
import { readOrders } from "../utils/ecommerceStorage";
import "../css/Ecommerce.css";

export default function EcommerceOrderHistory() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const syncOrders = () => setOrders(readOrders());
    syncOrders();
    window.addEventListener("order-history-change", syncOrders);
    window.addEventListener("storage", syncOrders);
    return () => {
      window.removeEventListener("order-history-change", syncOrders);
      window.removeEventListener("storage", syncOrders);
    };
  }, []);

  return (
    <div className="ecomm-app-screen">
      <EcommerceHeader />
      <main className="ecomm-order-screen">
        <section className="ecomm-order-header">
          <p>My Orders</p>
          <h1>Order History</h1>
        </section>

        {orders.length === 0 ? (
          <section className="ecomm-order-empty">
            <div>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
                <path d="M3 6h18" />
                <path d="M16 10a4 4 0 0 1-8 0" />
              </svg>
            </div>
            <h2>No orders yet</h2>
            <p>Your placed product orders will appear here after checkout.</p>
          </section>
        ) : (
          <div className="ecomm-order-list">
            {orders.map((order, index) => (
              <article className="ecomm-order-card" key={order.id || index}>
                <div className="ecomm-order-product">
                  {order.image && <img src={order.image} alt={order.title || "Order"} />}
                  <div>
                    <span>{order.brand || "Gama 567"}</span>
                    <h2>{order.title || "Product Order"}</h2>
                    <p>{formatDate(order.orderedAt)}</p>
                  </div>
                </div>

                <div className="ecomm-order-meta">
                  <div>
                    <span>Amount</span>
                    <strong>₹{order.price || 0}</strong>
                  </div>
                  <div>
                    <span>Status</span>
                    <strong className="ecomm-order-status">{order.status || "Placed"}</strong>
                  </div>
                  <div>
                    <span>Payment</span>
                    <strong>{order.paymentMethod || "UPI"}</strong>
                  </div>
                  <div>
                    <span>Txn ID</span>
                    <strong>{order.transactionId || order.id || "-"}</strong>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </main>
      <EcommerceFooter active="history" />
    </div>
  );
}

function formatDate(value) {
  if (!value) return "Date not available";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Date not available";

  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}
